define('lib/util/tda.context',['jquery'], function ($) {

  /*
    TDA CONTEXT HELPERS.
  */

  var tdaContext = {
    contextMap : {
      'BOS10':'NewEngland',
      'CAT10':'CentralAtlantic',
      'CHI10':'Midwest',
      'CIN10':'MY-OH-KY-TN',
      'CON10':'Connecticut',
      'DVR10':'Denver',
      'GNY10':'GreaterNY',
      'GOC10':'GoldCoast',
      'GST10':'GST',
      // 'INE10':'*',
      'INW10':'InlandNorthWest',
      'KAC10':'Central',
      'NCA10':'Norcal',
      // 'NWT10':'*',
      'PHX10':'Phoenix',
      'PTL10':'PacificNorthwest',
      'SET10':'SouthEastToyota',
      // 'SID10':'*',
      'SND10':'SanDiego',
      'SOC10':'SoCal',
      'TRE10':'TriStateEast',
      'TRI10':'TriState',
      'UST10':'UpstateNY',
      'WWN10':'WesternWashington',
      'WWW':'',
    },

    //GET A HUMAN READABLE VERSION OF THE CONTEXT , USED FOR PAGE TITLE.
    getReadableContext:function(tdaCode) {
      var res = this.contextMap[tdaCode];
      return res;
    }
  }
   return tdaContext;
});

